import DgSvgIcon from './src/main.vue'

// 为组件提供 install 安装方法，供按需引入
DgSvgIcon.install = function (Vue) {
  Vue.component(DgSvgIcon.name, DgSvgIcon)
}
export default DgSvgIcon

export { DgSvgIcon }